import { render, staticRenderFns } from "./canceled_orders.vue?vue&type=template&id=67966a0c&"
import script from "./canceled_orders.vue?vue&type=script&lang=js&"
export * from "./canceled_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports